<template>
    <div>
        <div class="rounded bg-white shadow-md" style="min-height: 590px">
            <contact-external-email-section :contact="contact"  :email="contact.email" :can-edit="'true'" :exchange="exchange" :hasSequencesAccess="hasSequencesAccess" :company="company">
            </contact-external-email-section>
        </div>
    </div>
</template>

<script>
import ContactExternalEmailSection from "./contact-external-email-section";
export default {
    name: "contact-emails",
    components: {ContactExternalEmailSection},
    props: ['company', 'contact', 'masks', 'symbols', 'canEdit', 'hasSequencesAccess','exchange'],
}
</script>

<style scoped>

</style>
